import React, { FC } from 'react';
import Book from './Book';
import { IBook, IEntry } from 'redux/app/vessel/types';

interface IBooksProps {
	onClick: (entry: IEntry) => void;
	books: IBook[];
	isLoading: boolean;
}

const temporarilyHiddenBooks = ['dayLogConfig'];

const Books: FC<IBooksProps> = (props) => {
	const { onClick, books, isLoading } = props;
	if (isLoading) return (
		<div className="flex flex-col items-center justify-center gap-4 my-4">
			<div className="w-20 h-20 border-4 border-r-4 border-blue-300 border-solid rounded-full border-t-transparent animate-spin opacity-80"></div>
			<p className="text-gray-600">
				Loading Books...
			</p>
		</div>
	)
	return (
		<div className="p-5 flex flex-col gap-y-2 lg:h-[calc(100vh-200px)] h-[calc(100vh-35px)] overflow-y-scroll ws-scroll_transparent">
			{books.map((book, index) => {
				const { id, title, type, bookType } = book;
				// INFO: if book is dayLogConfig, then hide it temporarily
				// This is because we currently don't have support for it.
				if (temporarilyHiddenBooks.includes(id)) return null;
				return (
					<button
						onClick={() =>
							onClick &&
							onClick({ id, title, typeOfLogs: title, type, bookType })
						}
						key={id + index}
					>
						<Book {...book} />
					</button>
				);
			})}
		</div>
	);
};

export default Books;
